import { defaultTheme } from '@classify/react-core-components/Theme';

const mediaMatch = {
  matcher: /(?:vimeo(?:pro)?.com)\/(?:[^\d]+)?(\d+)(?:.*)/,
  url: `https://player.vimeo.com/video/$1?color=${defaultTheme.palette.brand.primary.substr(1)}`,
};

export default { mediaMatch };
